/* eslint-disable no-unused-vars */
import {
  Button,
  Grid,
  Tabs,
  Tab,
  Typography,
  Box,
  CardContent,
  Card,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import PDialog from "../../components/pos/PDialog";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { styled } from "@mui/system";
import API from "../../utils/API";
import { yellow } from "@mui/material/colors";

const useStyles = makeStyles({});

const theme = createTheme({});

const TableButton = styled(Button)({
  width: "100%",
  fontSize: "0.6rem",
  height: "35px",
});

export default function SalesManSelector(props) {
  const { t } = useTranslation();
  const translate = t;

  //const [deliveryPersons, setDeliveryPersons] = useState([]);

  useEffect(() => {}, []);

  function handleClickCell(floorIx, rowIx, colIx) {
    /*let f = [...floors];
    f[floorIx].layout[rowIx][colIx]["selected"] = f[floorIx].layout[rowIx][
      colIx
    ].selected
      ? false
      : true;
    console.log(f);
    setFloors(f);*/
  }

  const content = (
    <div>
      <ThemeProvider>
        <Grid container spacing={"15px"}>
          {props.deliveryPersons.map((dPerson, floorIx) => (
            <Grid item xs={3} sx={{ height: "60px" }}>
              <TableButton
                style={{
                  fontSize: "15px",
                  height: "50px",
                  backgroundColor: yellow[200],
                }}
                onClick={() => {
                  props.setSalesManInfo(dPerson);
                  props.closeWindow(false);
                }}
              >
                {dPerson.name}
              </TableButton>
            </Grid>
          ))}
        </Grid>
      </ThemeProvider>
    </div>
  );

  function onCloseWindow() {
    props.closeWindow(false);
  }
  function onSave() {
    props.closeWindow(false);
  }

  return (
    <div>
      <PDialog
        content={content}
        title={"Delivery Person"}
        maxWidth={"md"}
        fullWidth={true}
        open={true}
        onCloseWindow={onCloseWindow}
        custumClose={false}
        hideSave={true}
        saveLabel={"Ok"}
        borderLess={false}
        onSave={onSave}
      ></PDialog>
    </div>
  );
}
